import Vue from 'vue'
import VueRouter from 'vue-router'

// HTTP
import PageNotFound from '@/views/http/PageNotFound'
import PermissionDenied from '@/views/http/PermissionDenied'

// AUTH
import AuthSignIn from '@/views/auth/SignIn'
import AuthSignUp from '@/views/auth/SignUp'
import AuthSettings from '@/views/auth/Settings'
import AuthPasswordReset from '@/views/auth/PasswordReset'
import AuthPasswordResetConfirm from '@/views/auth/PasswordResetConfirm'

// ACCOUNT
import AccountBasic from '@/views/account/Basic'
import AccountSettingsEmail from '@/views/account/Email'
import AccountSettingsBranding from '@/views/account/Branding'
import AccountSettingsInvoicing from '@/views/account/Invoicing'

/* --- integrations --- */
import Integrations from '@/views/integrations/Main'

/** built-in **/
import BillersBiller from '@/views/integrations/billers/Biller'
import BillersBuiltInSettings from '@/views/integrations/billers/built_in/Settings'
import BillersBuiltInRvds from '@/views/integrations/billers/built_in/ReportRvds'
import BillersBuiltInReportTransactional from '@/views/integrations/billers/built_in/ReportTransactional'

import PurchaseList from '@/views/integrations/billers/built_in/PurchaseList'
import PurchaseRetrieve from '@/views/integrations/billers/built_in/PurchaseRetrieve'
import RetentionList from '@/views/integrations/billers/built_in/RetentionList'
import RetentionRetrieve from '@/views/integrations/billers/built_in/RetentionRetrieve'
import RetentionCreate from '@/views/integrations/billers/built_in/RetentionCreate'

import RetentionBulkListCreate from '@/views/integrations/billers/built_in/RetentionBulkListCreate'
import RetentionBulkRetrieve from '@/views/integrations/billers/built_in/RetentionBulkRetrieve'
/** built-in **/

import IntegrationsDefontana from '../views/integrations/defontana/Main'
import IntegrationsFacturapi from '../views/integrations/facturapi/Main'
import IntegrationsNfe from '../views/integrations/nfe/Main'

import SupplierRetrieveUpdate from '@/views/integrations/billers/built_in/SupplierRetrieveUpdate'
import SupplierListCreate from '@/views/integrations/billers/built_in/SupplierListCreate'
/* --- end integrations --- */

import AccountSettingsBank from '@/views/account/Bank'
import AccountSuccessBank from '@/views/account/BankSuccess'
import AccountSettingsPayments from '@/views/account/Payments'
import AccountSettingsWebhooksListCreate from '@/views/account/WebhooksListCreate'
import AccountSettingsWebhooksRetrieveUpdate from '@/views/account/WebhooksRetrieveUpdate'
import AccountBilling from '@/views/account/Billing'
import AccountMembers from '@/views/account/Members'
import AccountChoose from '@/views/account/Choose'
import AccountDashboard from '@/views/account/Dashboard'
import AccountSetup from '@/views/account/Setup'
import AccountOnboarding from '@/views/account/Onboarding'
import AccountImportInvoices from '@/views/account/ImportInvoices'
import AccountImportCreditNotes from '@/views/account/ImportCreditNotes'
import AccountExports from '@/views/account/Exports'
import AccountCustomerExport from '@/views/account/exports/CustomerExport'
import AccountExportSubscription from '@/views/account/exports/ExportSubscription'
import AccountExportInvoices from '@/views/account/exports/ExportInvoices'
import AccountExportCreditNote from '@/views/account/exports/ExportCreditNote'
import AccountExportPayment from '@/views/account/exports/ExportPayment'
import TransactionExport from '@/views/account/exports/TransactionExport'
import AccountImports from '@/views/account/Imports'
import AccountImportCustomers from '@/views/account/imports/ImportCustomers'
import ImportUsages from '@/views/account/imports/ImportUsages'
import AccountQuickstart from '@/views/account/Quickstart'

// INVOICES
import InvoiceCreate from '@/views/invoice/InvoiceCreate'
import InvoiceRetrieve from '@/views/invoice/InvoiceRetrieve'
import InvoiceList from '@/views/invoice/InvoiceList'
import InvoiceBulkRetrieve from '@/views/invoice/InvoiceBulkRetrieve'
import InvoiceBulkListCreate from '@/views/invoice/InvoiceBulkListCreate'
import CreditNoteList from '@/views/invoice/CreditNoteList'
import CreditNoteRetrieve from '@/views/invoice/CreditNoteRetrieve'
import DebitNoteRetrieve from '@/views/invoice/DebitNoteRetrieve'

// ORDERS
import OrderCreate from '@/views/orders/OrderCreate'
import OrderRetrieve from '@/views/orders/OrderRetrieve'
import OrderList from '@/views/orders/OrderList'

// CUSTOMERS
import CustomerRetrieveUpdate from '@/views/customer/CustomerRetrieveUpdate'
import CustomerListCreate from '@/views/customer/CustomerListCreate'
import ContactRetrieveUpdate from '@/views/customer/ContactRetrieveUpdate'
import ContactListCreate from '@/views/customer/ContactListCreate'

// SUBSCRIPTIONS
import CouponRetrieveUpdate from '@/views/subscription/CouponRetrieveUpdate'
import CouponListCreate from '@/views/subscription/CouponListCreate'
import AddonRetrieveUpdate from '@/views/subscription/AddonRetrieveUpdate'
import AddonListCreate from '@/views/subscription/AddonListCreate'
import PlanCreate from '@/views/subscription/PlanCreate'
import PlanRetrieveUpdate from '@/views/subscription/PlanRetrieveUpdate'
import ProductRetrieveUpdate from '@/views/subscription/ProductRetrieveUpdate'
import ProductListCreate from '@/views/subscription/ProductListCreate'
import SubscriptionCreate from '@/views/subscription/SubscriptionCreate'
import SubscriptionRetrieve from '@/views/subscription/SubscriptionRetrieve'
import SubscriptionList from '@/views/subscription/SubscriptionList'
import SubscriptionUpdate from '@/views/subscription/SubscriptionUpdate'
import UsageListCreate from '@/views/subscription/UsageListCreate'

// PAYMENTS
import PaymentListCreate from '@/views/payment/PaymentListCreate'
import PaymentRetrieve from '@/views/payment/PaymentRetrieve'

// COMPONENTS
import Components from '@/views/widgets/Main'
import BaseCreateUpdate from '@/views/widgets/customer-base/BaseCreateUpdate'
import BaseList from '@/views/widgets/customer-base/BaseList'
import BaseRetrieve from '@/views/widgets/customer-base/BaseRetrieve'
import FormCreate from '@/views/widgets/signup-forms/FormCreate'
import FormDetail from '@/views/widgets/signup-forms/FormDetail'
import FormList from '@/views/widgets/signup-forms/FormList'
import FormPreview from '@/views/widgets/signup-forms/FormPreview'
import FormUpdate from '@/views/widgets/signup-forms/FormUpdate'

// BANKS
import TransactionList from '@/views/bank/TransactionList'

// REPORT
import MetricList from '@/views/reports/metrics/MetricList'
import DefaultDashboardList from '@/views/reports/dashboards/DefaultDashboardList'
import DashboardCreateUpdate from '@/views/reports/dashboards/DashboardCreateUpdate'
import Dashboards from '@/views/reports/dashboards/WelcomeDashboard'

// RECEIVABLES
import Receivables from '@/views/receivables/Main'
import ReminderList from '@/views/receivables/ReminderList'
import RuleViewSet from '@/views/receivables/RuleViewSet'

import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/auth/signin',
    name: 'AuthSignIn',
    component: AuthSignIn,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      title: 'Inicio de sesión'
    }
  },
  {
    path: '/auth/signup',
    name: 'AuthSignUp',
    component: AuthSignUp,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      title: 'Registro de usuario'
    }
  },
  {
    path: '/auth/settings',
    name: 'AuthSettings',
    component: AuthSettings,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      requireAuth: true,
      title: 'Configuraciones de usuario'
    }
  },
  {
    path: '/auth/password/reset',
    name: 'AuthPasswordReset',
    component: AuthPasswordReset,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      title: 'Restablecimiento de la contraseña'
    }
  },
  {
    path: '/auth/password/reset/confirm/:uid/:token',
    name: 'AuthPasswordResetConfirm',
    component: AuthPasswordResetConfirm,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      title: 'Confirmación restablecimiento de la contraseña'
    }
  },
  {
    path: '/account/settings/basic',
    name: 'AccountBasic',
    component: AccountBasic,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      showDetails: true,
      title: 'Configuración de la organización'
    }
  },
  {
    path: '/account/settings/email',
    name: 'AccountSettingsEmail',
    component: AccountSettingsEmail,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Email'
    }
  },
  {
    path: '/account/settings/branding',
    name: 'AccountSettingsBranding',
    component: AccountSettingsBranding,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Branding'
    }
  },
  {
    path: '/account/settings/invoicing',
    name: 'AccountSettingsInvoicing',
    component: AccountSettingsInvoicing,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Facturación'
    }
  },
  {
    path: '/account/settings/bank',
    name: 'AccountSettingsBank',
    component: AccountSettingsBank,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Banco'
    }
  },
  {
    path: '/account/settings/bank/success',
    name: 'AccountSuccessBank',
    component: AccountSuccessBank,
    meta: {
      displayAppBar: false,
      displayNavigationDrawer: false,
      displayDrawer: false,
      displayOrganization: false,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Banco success'
    }
  },
  {
    path: '/account/settings/payments',
    name: 'AccountSettingsPayments',
    component: AccountSettingsPayments,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Pagos'
    }
  },
  {
    path: '/account/settings/webhooks',
    name: 'AccountSettingsWebhooksListCreate',
    component: AccountSettingsWebhooksListCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Webhooks'
    }
  },
  {
    path: '/account/settings/webhooks/:id',
    name: 'AccountSettingsWebhooksRetrieveUpdate',
    component: AccountSettingsWebhooksRetrieveUpdate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      title: 'Webhooks'
    }
  },
  {
    path: '/account/settings/billing',
    name: 'AccountBilling',
    component: AccountBilling,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      title: 'Facturación de Piriod'
    }
  },
  {
    path: '/account/settings/members',
    name: 'AccountMembers',
    component: AccountMembers,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      requireAccount: true,
      title: 'Equipo'
    }
  },
  {
    path: '/account/choose',
    name: 'AccountChoose',
    component: AccountChoose,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayDrawer: false,
      displayOrganization: false,
      requireAuth: true,
      requireAccount: false,
      title: 'Cambio de cuenta'
    }
  },
  {
    path: '/',
    name: 'Index',
    component: AccountChoose,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayDrawer: false,
      displayOrganization: false,
      requireAuth: true,
      requireAccount: true,
      title: 'Cambio de cuenta'
    }
  },
  {
    path: '/account/dashboard',
    name: 'AccountDashboard',
    component: AccountDashboard,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'AccountDashboard',
      requireAuth: true,
      requireAccount: true,
      title: 'Dashboard'
    }
  },
  {
    path: '/account/setup',
    name: 'AccountSetup',
    component: AccountSetup,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayDrawer: false,
      displayOrganization: false,
      parent: 'AccountBasic',
      requireAuth: true,
      title: 'Setup'
    }
  },
  {
    path: '/account/onboarding',
    name: 'AccountOnboarding',
    component: AccountOnboarding,
    meta: {
      displayAppBar: false,
      displayNavigationDrawer: false,
      displayDrawer: false,
      displayOrganization: false,
      parent: 'AccountBasic',
      requireAuth: true,
      title: 'Onboarding',
      whiteBackground: true
    }
  },
  {
    path: '/account/import/invoices',
    name: 'AccountImportInvoices',
    component: AccountImportInvoices,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      title: 'Importación de facturas'
    }
  },
  {
    path: '/account/import/credit-notes',
    name: 'AccountImportCreditNotes',
    component: AccountImportCreditNotes,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true,
      title: 'Importación de facturas'
    }
  },
  {
    path: '/account/exports',
    name: 'AccountExports',
    component: AccountExports,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/exports/customers',
    name: 'AccountCustomerExport',
    component: AccountCustomerExport,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/exports/subscriptions',
    name: 'AccountExportSubscription',
    component: AccountExportSubscription,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/exports/invoices',
    name: 'AccountExportInvoices',
    component: AccountExportInvoices,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/exports/credit_notes',
    name: 'AccountExportCreditNote',
    component: AccountExportCreditNote,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/exports/payments',
    name: 'AccountExportPayment',
    component: AccountExportPayment,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/exports/ach_transfers',
    name: 'TransactionExport',
    component: TransactionExport,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/imports',
    name: 'AccountImports',
    component: AccountImports,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/imports/customers',
    name: 'AccountImportCustomers',
    component: AccountImportCustomers,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/imports/usages',
    name: 'ImportUsages',
    component: ImportUsages,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'AccountBasic',
      requireAuth: true
    }
  },
  {
    path: '/account/quickstart',
    name: 'AccountQuickstart',
    component: AccountQuickstart,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'AccountQuickstart',
      requireAuth: true,
      requireAccount: true,
      title: 'Quickstart'
    }
  },
  {
    path: '/invoices/create',
    name: 'InvoiceCreate',
    component: InvoiceCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Crear factura'
    }
  },
  {
    path: '/invoices/:id',
    name: 'InvoiceRetrieve',
    component: InvoiceRetrieve,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Factura'
    }
  },
  {
    path: '/invoices',
    name: 'InvoiceList',
    component: InvoiceList,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Facturas'
    }
  },
  {
    path: '/invoices/:id/edit',
    name: 'InvoiceUpdate',
    component: InvoiceCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Editar factura'
    }
  },
  {
    path: '/bulks/invoices',
    name: 'InvoiceBulkListCreate',
    component: InvoiceBulkListCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Procesos de facturación por lotes'
    }
  },
  {
    path: '/bulks/invoices/:id',
    name: 'InvoiceBulkRetrieve',
    component: InvoiceBulkRetrieve,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Facturación por lotes'
    }
  },
  {
    path: '/credit-notes',
    name: 'CreditNoteList',
    component: CreditNoteList,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Notas de crédito'
    }
  },
  {
    path: '/credit-notes/:id',
    name: 'CreditNoteRetrieve',
    component: CreditNoteRetrieve,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Nota de crédito'
    }
  },
  {
    path: '/debit-notes/:id',
    name: 'DebitNoteRetrieve',
    component: DebitNoteRetrieve,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Nota de débito'
    }
  },
  {
    path: '/orders/create',
    name: 'OrderCreate',
    component: OrderCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Crear orden'
    }
  },
  {
    path: '/orders/:id',
    name: 'OrderRetrieve',
    component: OrderRetrieve,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Orden'
    }
  },
  {
    path: '/orders',
    name: 'OrderList',
    component: OrderList,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Órdenes'
    }
  },
  {
    path: '/orders/:id/edit',
    name: 'OrderUpdate',
    component: OrderCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Editar orden'
    }
  },
  {
    path: '/customers/:id',
    name: 'CustomerRetrieveUpdate',
    component: CustomerRetrieveUpdate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'CustomerListCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Cliente'
    }
  },
  {
    path: '/customers',
    name: 'CustomerListCreate',
    component: CustomerListCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'CustomerListCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Clientes'
    }
  },
  {
    path: '/contacts/:id',
    name: 'ContactRetrieveUpdate',
    component: ContactRetrieveUpdate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'CustomerListCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Persona'
    }
  },
  {
    path: '/contacts',
    name: 'ContactListCreate',
    component: ContactListCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'CustomerListCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Personas'
    }
  },
  {
    path: '/transactions',
    name: 'TransactionList',
    component: TransactionList,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'PaymentListCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Transferencias'
    }
  },
  {
    path: '/coupons/:id',
    name: 'CouponRetrieveUpdate',
    component: CouponRetrieveUpdate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Cupón'
    }
  },
  {
    path: '/coupons',
    name: 'CouponListCreate',
    component: CouponListCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Cupones'
    }
  },
  {
    path: '/addons/:id',
    name: 'AddonRetrieveUpdate',
    component: AddonRetrieveUpdate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Complemento'
    }
  },
  {
    path: '/addons',
    name: 'AddonListCreate',
    component: AddonListCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Complementos'
    }
  },
  {
    path: '/products',
    name: 'ProductListCreate',
    component: ProductListCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Productos'
    }
  },
  {
    path: '/products/:id',
    name: 'ProductRetrieveUpdate',
    component: ProductRetrieveUpdate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Producto'
    }
  },
  {
    path: '/plans/create',
    name: 'PlanCreate',
    component: PlanCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Crear plan'
    }
  },
  {
    path: '/plans/:id',
    name: 'PlanRetrieveUpdate',
    component: PlanRetrieveUpdate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Plan'
    }
  },
  {
    path: '/subscriptions/create',
    name: 'SubscriptionCreate',
    component: SubscriptionCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Crear suscripción'
    }
  },
  {
    path: '/subscriptions/:id',
    name: 'SubscriptionRetrieve',
    component: SubscriptionRetrieve,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Suscripción'
    }
  },
  {
    path: '/subscriptions',
    name: 'SubscriptionList',
    component: SubscriptionList,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Suscripciones'
    }
  },
  {
    path: '/subscriptions/:id/edit',
    name: 'SubscriptionUpdate',
    component: SubscriptionUpdate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Editar suscripción'
    }
  },
  {
    path: '/usages',
    name: 'UsageListCreate',
    component: UsageListCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Registros de uso'
    }
  },
  {
    path: '/payments/:id',
    name: 'PaymentRetrieve',
    component: PaymentRetrieve,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'PaymentListCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Detalles de pagos'
    }
  },
  {
    path: '/components',
    name: 'Components',
    component: Components,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'Components',
      requireAuth: true,
      requireAccount: true,
      title: 'Componentes'
    }
  },
  {
    path: '/customer-base',
    name: 'BaseList',
    component: BaseList,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'BaseList',
      requireAuth: true,
      requireAccount: true,
      title: 'Customer Base'
    }
  },
  {
    path: '/customer-base/create',
    name: 'BaseCreate',
    component: BaseCreateUpdate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'BaseList',
      requireAuth: true,
      requireAccount: true,
      title: 'Customer Base'
    }
  },
  {
    path: '/customer-base/:id',
    name: 'BaseRetrieve',
    component: BaseRetrieve,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'BaseList',
      requireAuth: true,
      requireAccount: true,
      title: 'Customer Base'
    }
  },
  {
    path: '/customer-base/:id/edit',
    name: 'BaseUpdate',
    component: BaseCreateUpdate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'BaseList',
      requireAuth: true,
      requireAccount: true,
      title: 'Customer Base'
    }
  },
  {
    path: '/signup-forms/create',
    name: 'FormCreate',
    component: FormCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'FormCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Signup Forms'
    }
  },
  {
    path: '/signup-forms/:id',
    name: 'FormDetail',
    component: FormDetail,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'FormList',
      requireAuth: true,
      requireAccount: true,
      title: 'Signup Forms'
    }
  },
  {
    path: '/signup-forms',
    name: 'FormList',
    component: FormList,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'FormList',
      requireAuth: true,
      requireAccount: true,
      title: 'Signup Forms'
    }
  },
  {
    path: '/signup-forms/:id/preview',
    name: 'FormPreview',
    component: FormPreview,
    meta: {
      displayAppBar: false,
      displayNavigationDrawer: false,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'FormPreview',
      requireAuth: true,
      requireAccount: true,
      title: 'Signup Forms'
    }
  },
  {
    path: '/signup-forms/:id/edit',
    name: 'FormUpdate',
    component: FormUpdate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'FormUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Signup Forms'
    }
  },
  {
    path: '/payments',
    name: 'PaymentListCreate',
    component: PaymentListCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'PaymentListCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Pagos'
    }
  },
  {
    path: '/metrics/collections',
    name: 'MetricList',
    component: MetricList,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'DashboardUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Coleccción de Métricas'
    }
  },
  {
    path: '/dashboard/default',
    name: 'DefaultDashboardList',
    component: DefaultDashboardList,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'DashboardUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Dashboard predefinidos'
    }
  },
  {
    path: '/dashboard/favorites',
    name: 'Favorites',
    component: DefaultDashboardList,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'DashboardUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Dashboard favoritos'
    }
  },
  {
    path: '/dashboard/create',
    name: 'DashboardCreate',
    component: DashboardCreateUpdate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'DashboardUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Dashboard'
    }
  },
  {
    path: '/dashboard/:id/edit',
    name: 'DashboardUpdate',
    component: DashboardCreateUpdate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'DashboardUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Dashboard'
    }
  },
  {
    path: '/dashboard/:id/',
    name: 'DashboardRetrieve',
    component: DashboardCreateUpdate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'DashboardUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Detalles del Dashboard'
    }
  },
  {
    path: '/dashboards',
    name: 'Dashboards',
    component: Dashboards,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'DashboardUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Bienvenida dashboards'
    }
  },
  {
    path: '/integrations/billers/built_in',
    name: 'BillersBuiltInSettings',
    component: BillersBuiltInSettings,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Facturador'
    }
  },
  {
    path: '/integrations/defontana',
    name: 'IntegrationsDefontana',
    component: IntegrationsDefontana,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Defontana - Integraciones'
    }
  },
  {
    path: '/integrations/facturapi',
    name: 'IntegrationsFacturapi',
    component: IntegrationsFacturapi,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Facturapi - Integraciones'
    }
  },
  {
    path: '/integrations/nfe',
    name: 'IntegrationsNfe',
    component: IntegrationsNfe,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'NFE.io - Integraciones'
    }
  },
  {
    path: '/integrations/billers/:id',
    name: 'BillersBiller',
    component: BillersBiller,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Facturador'
    }
  },
  {
    path: '/integrations/billers/built_in/rvds',
    name: 'BillersBuiltInRvds',
    component: BillersBuiltInRvds,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Reporte RVD'
    }
  },
  {
    path: '/integrations/billers/built_in/transactional',
    name: 'BillersBuiltInReportTransactional',
    component: BillersBuiltInReportTransactional,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Reporte transaccional'
    }
  },
  {
    path: '/integrations',
    name: 'Integrations',
    component: Integrations,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: false,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Integraciones'
    }
  },
  {
    path: '/integrations/billers/built_in/purchases',
    name: 'PurchaseList',
    component: PurchaseList,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Compras'
    }
  },
  {
    path: '/integrations/billers/built_in/purchases/:id',
    name: 'PurchaseRetrieve',
    component: PurchaseRetrieve,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Compra'
    }
  },
  {
    path: '/integrations/billers/built_in/retentions',
    name: 'RetentionList',
    component: RetentionList,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Retenciones'
    }
  },
  {
    path: '/integrations/billers/built_in/retentions/:id',
    name: 'RetentionRetrieve',
    component: RetentionRetrieve,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Compra'
    }
  },
  {
    path: '/integrations/billers/built_in/retentions/:id/edit',
    name: 'RetentionUpdate',
    component: RetentionCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Editar retención'
    }
  },
  {
    path: '/integrations/billers/built_in/retentions/create',
    name: 'RetentionCreate',
    component: RetentionCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Crear retención'
    }
  },
  {
    path: '/integrations/billers/built_in/bulks/retentions',
    name: 'RetentionBulkListCreate',
    component: RetentionBulkListCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Retenciones'
    }
  },
  {
    path: '/integrations/billers/built_in/bulks/retentions/:id',
    name: 'RetentionBulkRetrieve',
    component: RetentionBulkRetrieve,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Retenciones'
    }
  },
  {
    path: '/integrations/billers/built_in/suppliers/:id',
    name: 'SupplierRetrieveUpdate',
    component: SupplierRetrieveUpdate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Proveedor'
    }
  },
  {
    path: '/integrations/billers/built_in/suppliers',
    name: 'SupplierListCreate',
    component: SupplierListCreate,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'Integrations',
      requireAuth: true,
      requireAccount: true,
      title: 'Proveedores'
    }
  },
  {
    path: '/receivables',
    name: 'Receivables',
    component: Receivables,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'PaymentListCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Cuentas por cobrar'
    }
  },
  {
    path: '/receivables/reminders',
    name: 'ReminderList',
    component: ReminderList,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'PaymentListCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Recordatorios de pago'
    }
  },
  {
    path: '/receivables/rules',
    name: 'RuleViewSet',
    component: RuleViewSet,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayDrawer: true,
      displayOrganization: true,
      parent: 'PaymentListCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Reglas de recordatorios de pago'
    }
  },
  {
    path: '*',
    name: 'PageNotFound',
    component: PageNotFound,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayDrawer: false,
      displayOrganization: true,
      title: 'Página no encontrada'
    }
  },
  {
    path: '*',
    name: 'PermissionDenied',
    component: PermissionDenied,
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayDrawer: false,
      displayOrganization: true,
      title: 'Permiso denegado'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('global/CANCEL_PENDING_REQUESTS')
  if (to.meta.requireAuth) {
    if (store.state.auth.token) {
      if (to.meta.requireAccount) {
        if (store.state.auth.account.id) {
          next()
        } else {
          next({ path: '/account/choose' })
        }
      } else {
        next()
      }
    } else {
      next({
        path: '/auth/signin',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title + ' - Piriod' : 'Piriod'
  next(true)
})

export default router
